/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    UserListItemVm,
    UserListItemVmFromJSON,
    UserListItemVmFromJSONTyped,
    UserListItemVmToJSON,
} from './';

/**
 * 
 * @export
 * @interface UserListItemVmPaginatedSearchResponse
 */
export interface UserListItemVmPaginatedSearchResponse {
    /**
     * 
     * @type {Array<UserListItemVm>}
     * @memberof UserListItemVmPaginatedSearchResponse
     */
    items?: Array<UserListItemVm> | null;
    /**
     * 
     * @type {number}
     * @memberof UserListItemVmPaginatedSearchResponse
     */
    totalCount?: number;
    /**
     * 
     * @type {number}
     * @memberof UserListItemVmPaginatedSearchResponse
     */
    from?: number;
    /**
     * 
     * @type {number}
     * @memberof UserListItemVmPaginatedSearchResponse
     */
    to?: number;
    /**
     * 
     * @type {number}
     * @memberof UserListItemVmPaginatedSearchResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof UserListItemVmPaginatedSearchResponse
     */
    size?: number;
}

export function UserListItemVmPaginatedSearchResponseFromJSON(json: any): UserListItemVmPaginatedSearchResponse {
    return UserListItemVmPaginatedSearchResponseFromJSONTyped(json, false);
}

export function UserListItemVmPaginatedSearchResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserListItemVmPaginatedSearchResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': !exists(json, 'items') ? undefined : (json['items'] === null ? null : (json['items'] as Array<any>).map(UserListItemVmFromJSON)),
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'from': !exists(json, 'from') ? undefined : json['from'],
        'to': !exists(json, 'to') ? undefined : json['to'],
        'page': !exists(json, 'page') ? undefined : json['page'],
        'size': !exists(json, 'size') ? undefined : json['size'],
    };
}

export function UserListItemVmPaginatedSearchResponseToJSON(value?: UserListItemVmPaginatedSearchResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': value.items === undefined ? undefined : (value.items === null ? null : (value.items as Array<any>).map(UserListItemVmToJSON)),
        'totalCount': value.totalCount,
        'from': value.from,
        'to': value.to,
        'page': value.page,
        'size': value.size,
    };
}


